import React, { useState } from 'react';
import { alpha, useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { SimButton } from 'components/SimButton';

import EventDetailsPopup from './EventDetailsPopup';

const SimPopupCardDetails = ({ title }) => {
	const theme = useTheme();
	const [open, setOpen] = useState(false);

	return (
		<Box display={'flex'} justifyContent={'center'} alignItems={'center'} width={1}>
			<Box width={1}>
				<SimButton
					backgroundColor={alpha(theme.palette.primary.light, 0.1)}
					fontWeight='700'
					size='large'
					color={'primary'}
					variant={'outlined'}
					onClick={() => setOpen(true)}>
					See Details
				</SimButton>
				<EventDetailsPopup title={title} open={open} onClose={() => setOpen(false)} />
			</Box>
		</Box>
	);
};

SimPopupCardDetails.propTypes = {
	title: PropTypes.string.isRequired
};

export { SimPopupCardDetails };
